<template>
  <div>
    <RightTitle title="系统消息"></RightTitle>

    <!-- 搜索表单 -->
    <div class="uar_form">
      <el-form ref="form" :inline="true" :model="filter" label-width="80px" size="medium">
        <el-form-item label="标题">
          <el-input v-model="filter.title" clearable placeholder="搜索标题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 数据表格 -->
    <div class="uar_form">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="title" label="标题"></el-table-column>
        <el-table-column prop="isRead" label="读取状态" width="120" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.isRead == 1">已读</span>
            <span v-else>未读</span>
          </template>
        </el-table-column>
        <el-table-column prop="addTime" label="时间" width="150" align="center"></el-table-column>
        <el-table-column label="详情" width="100" align="center">
          <template slot-scope="scope">
            <el-button @click="showInfo(scope.row)" type="text" size="small">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="uar_form page_area">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="dataTotal"
        @current-change="currentChange"
      ></el-pagination>
    </div>

    <!-- 消息详情 -->
    <el-dialog title="消息详情" :visible.sync="dialogVisible" width="30%">
      <div class="sys_content">
        <el-scrollbar class="page-component__scroll">
          <div v-html="messageObj.content"></div>
        </el-scrollbar>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 加载组件
import RightTitle from "../../components/RightTitle";
// 加载api
import { getSystemMessage, setSystemMessageRead } from "../../api/user_message";
// 加载函数
import { formatQuery } from "../../utils/fn";
export default {
  name: "system",
  components: {
    RightTitle,
  },
  beforeRouteEnter(to, from, next) {
    getSystemMessage(to.query).then(res => {
      next(vm => {
        vm.tableData = res.data.list;
        vm.dataTotal = res.data.count;
      });
    });
  },

  beforeRouteUpdate(to, from, next) {
    getSystemMessage(to.query).then(res => {
      this.tableData = res.data.list;
      this.dataTotal = res.data.count;
    });
    next();
  },
  data() {
    return {
      filter: {
        title: "" //标题搜索
      },
      tableData: [],
      dataTotal: 0,
      messageObj: {},
      dialogVisible: false
    };
  },
  methods: {
    showInfo(row) {
      this.messageObj = row;
      setSystemMessageRead({ messageID: row.id }).then(res => {
        if (res.status == 200) {
          row.isRead = 1;
          this.dialogVisible = true;
        } else {
          this.$notify({
            title: "警告",
            message: res.message,
            type: "warning"
          });
        }
      });
    },
    getDialogVisible(data) {
      this.dialogVisible = data;
    },
    // 搜索
    search() {
      this.$router.push({ query: { ...formatQuery(this.filter), page: 1 } });
    },
    // 改变当前页
    currentChange(page) {
      this.$router.push({ query: { ...this.$route.query, page } });
    }
  }
};
</script>

<style scoped>
.sys_content {
  height: 400px;
  overflow: hidden;
}
</style>